import Icon from '../../../components/AppIcon';

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-primary via-secondary to-primary text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl mb-6">
            Ready to Start Your Commercial Project?
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-8 font-body leading-relaxed">
            Whether you're planning a new installation, need emergency support, or want to discuss a preventive maintenance program, our team is ready to help.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-all">
            <div className="bg-accent/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Phone" size={32} />
            </div>
            <h3 className="font-headline font-bold text-xl mb-2">Call Directly</h3>
            <p className="text-white/80 mb-4 font-body">Speak with our commercial team</p>
            <a
              href="tel:0827935785"
              className="text-accent font-semibold hover:text-accent/80 transition-colors font-accent text-lg"
            >
              082 793 5785
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-all">
            <div className="bg-accent/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Mail" size={32} />
            </div>
            <h3 className="font-headline font-bold text-xl mb-2">Email Us</h3>
            <p className="text-white/80 mb-4 font-body">Send project details</p>
            <a
              href="mailto:info@meriodine.co.za"
              className="text-accent font-semibold hover:text-accent/80 transition-colors font-body"
            >
              info@meriodine.co.za
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-all">
            <div className="bg-accent/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Calendar" size={32} />
            </div>
            <h3 className="font-headline font-bold text-xl mb-2">Schedule Consultation</h3>
            <p className="text-white/80 mb-4 font-body">Book a site visit</p>
            <a
              href="/contact"
              className="text-accent font-semibold hover:text-accent/80 transition-colors font-body"
            >
              Request Appointment
            </a>
          </div>
        </div>

        <div className="text-center">
          <a
            href="tel:0827935785"
            className="inline-flex items-center gap-3 bg-accent text-accent-foreground px-10 py-5 rounded-lg font-semibold text-xl hover:bg-accent/90 transition-all emergency-cta shadow-2xl"
          >
            <Icon name="Phone" size={28} />
            <span className="font-accent">Emergency: 082 793 5785</span>
          </a>
          <p className="mt-6 text-white/80 font-body">Available 24/7 for commercial emergencies</p>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
          <div className="text-center">
            <p className="text-4xl md:text-5xl font-bold mb-2 font-headline">30+</p>
            <p className="text-white/80 text-sm font-body">Years Experience</p>
          </div>
          <div className="text-center">
            <p className="text-4xl md:text-5xl font-bold mb-2 font-headline">500+</p>
            <p className="text-white/80 text-sm font-body">Projects Completed</p>
          </div>
          <div className="text-center">
            <p className="text-4xl md:text-5xl font-bold mb-2 font-headline">24/7</p>
            <p className="text-white/80 text-sm font-body">Emergency Support</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;